module.exports = __webpack_public_path__ + "img/DNADamage-LICA_GSE146409.9e1674ea.png";